import Vue from 'vue'

const blobURL = URL.createObjectURL(new Blob(
  [
    '(',

    function() {
      const intervalIds = {}

      // 监听message 开始执行定时器或者销毁
      self.onmessage = function onMsgFunc(e) {
        const { command, data } = e.data

        switch (command) {
          case 'interval:start': // 开启定时器
            const intervalId = setInterval(() => {
              postMessage({
                message: 'interval:tick',
                id: data.id
              })
            }, data.interval || 200)

            postMessage({
              message: 'interval:started',
              id: data.id
            })

            intervalIds[data.id] = intervalId
            break
          case 'interval:clear': // 销毁
            clearInterval(intervalIds[data.id])

            postMessage({
              message: 'interval:cleared',
              id: data.id
            })

            delete intervalIds[data.id]
            break
        }
      }
    }.toString(),

    ')()'
  ],
  { type: 'application/javascript' }
))

const worker = new Worker(blobURL)

Vue.prototype.$worker = worker

export default worker
